import { readUz, type RequestRecord } from './requests-api.js';

/**
 * «Nima haqida» ustuni — maketdagi qisqa tavsif (`D2`).
 *
 * Har bir ariza turining payload'i har xil, shuning uchun bitta
 * `switch` o'rniga TUR → funksiya reestri (docs/03-CONVENTIONS.md §7):
 * yangi tur qo'shilsa `tsc` shu yerda ham yozishni talab qiladi.
 *
 * TOZA funksiya — alohida sinaladi.
 */
type Payload = Record<string, unknown>;

function str(payload: Payload, key: string): string {
  return readUz(payload[key]);
}

const SUMMARIES: Record<string, (payload: Payload) => string> = {
  product: (payload) => {
    const title = str(payload, 'productTitle');
    const variant = str(payload, 'variantTitle');
    const quantity = typeof payload.quantity === 'number' ? payload.quantity : 1;
    const parts = [title, variant].filter(Boolean).join(' · ');
    return quantity > 1 ? `${parts} × ${quantity}` : parts;
  },

  cart: (payload) => {
    const items = Array.isArray(payload.items) ? (payload.items as Payload[]) : [];
    const first = items[0] ? str(items[0], 'productTitle') : '';
    if (items.length <= 1) return first;
    return `${first} va yana ${items.length - 1} ta pozitsiya`;
  },

  drone_show: (payload) => {
    const parts = [str(payload, 'eventType'), str(payload, 'eventCity')].filter(Boolean);
    return parts.join(' · ');
  },

  repair: (payload) => str(payload, 'droneModel'),
  course: (payload) => str(payload, 'courseTitle'),
  service: (payload) => str(payload, 'serviceTitle'),
  general: (payload) => str(payload, 'subject'),
};

export function requestSummary(request: RequestRecord): string {
  const payload = (request.payload ?? {}) as Payload;
  const summary = SUMMARIES[request.type]?.(payload) ?? '';

  // Payload bo'sh bo'lsa mijozning izohi ko'rsatiladi — qator
  // butunlay bo'sh qolmasin
  if (summary) return summary;
  return request.comment ? truncate(request.comment, 80) : '—';
}

function truncate(text: string, max: number): string {
  const clean = text.replace(/\s+/g, ' ').trim();
  return clean.length > max ? `${clean.slice(0, max - 1)}…` : clean;
}
